import { defineStore } from 'pinia'

export const useAppStore = defineStore('appstore', {
    state: () => {
        return {
            User: { },
            Token: '',
            Expiry: null
        }
    },
    getters: {
        IsAuthenticated: (state) => {
            let token = state.Token;
            let expiry = state.Expiry;
            return token !== '' && expiry !== null && new Date(expiry) > new Date();
        }
    },
    actions: {
        logIn(model) {
            this.Token = model.token;
            this.Expiry = new Date(model.expiry);
            this.User = model.user;
        },
        logOut() {
            this.Token = '';
            this.Expiry = null;
            this.User = {};        
        },
        updateUser(user) {
            this.User = user; // Update the user information in the store
        },
    },
    persist: {
        storage: localStorage,
        paths : undefined
    }
});

